import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20 13v2h-7v-2h7Zm0-3.5v2h-9v-2h9ZM20 6v2H6V6h14ZM8 15v3H6v-3H3v-2h3v-3h2v3h3v2H8Z" }, null, -1)
  ]))]))
}
export default { render: render }